import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PromotionModalFooter({
  children,
  disabled = false,
  type = 'submit',
  onClick,
}) {
  return (
    <div className="flex justify-end border-t border-slate-100 bg-slate-50/60 px-5 py-4 sm:px-8 sm:py-5">
      <Button
        type={type}
        disabled={disabled}
        onClick={onClick}
        className="group h-12 cursor-pointer bg-linear-to-r from-brand-600 to-brand-700 px-8 text-base font-semibold shadow-md shadow-brand-900/20 hover:from-brand-700 hover:to-brand-800 hover:shadow-lg disabled:cursor-not-allowed disabled:from-slate-300 disabled:to-slate-400 disabled:shadow-none"
      >
        {children}
        <ArrowRight
          className="ml-2 size-4 transition-transform group-hover:translate-x-0.5"
          aria-hidden="true"
        />
      </Button>
    </div>
  );
}